import { Trans } from "@lingui/macro";
import styled from "styled-components";
import { body1, heading4 } from "~/guidelines/Typography";

const SectionWrapper = styled.section`
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  justify-content: center;
  align-items: flex-start;
  gap: 32px;
  margin: 32px;
  padding: 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    flex-direction: row;
    gap: 80px;
    margin: 80px;
    padding: 0 80px;
  }
`;

const LeftBlock = styled.div`
  ${heading4};
  width: 100%;
  font-size: 22px;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    width: 50%;
  }
`;

const RightBlock = styled.div`
  ${body1};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  padding-left: 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    padding-left: 50px;
    width: 50%;
  }
`;

const Paragraph = styled.p`
  margin: 0;
`;

const ConnectedHotelsSection = () => (
  <SectionWrapper>
    <LeftBlock>
      <Trans>
        Authentic and connected hotels at the heart of our territories
      </Trans>
    </LeftBlock>

    <RightBlock>
      <Paragraph>
        <Trans>
          We transform <b>distinctive buildings</b> into <b>connected hotels</b>{" "}
          with high-end comfort and optimized operations. Our ambition: to
          become the French benchmark for autonomous hospitality by combining
          proprietary technology and heritage rehabilitation.
        </Trans>
      </Paragraph>

      <br />

      <Paragraph>
        <Trans>
          Thanks to our <b>technological DNA</b>, we optimize operational
          management and offer investors a high-performance solution, combining
          performance, sustainable impact and resilience in the face of new
          expectations in the hotel market.
        </Trans>
      </Paragraph>
    </RightBlock>
  </SectionWrapper>
);

export default ConnectedHotelsSection;
